import { ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
//import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
//import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { MatExpansionModule } from '@angular/material';
import { MatIconModule, MatInputModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CommService } from '../comm.service'
import { HttpClient } from '@angular/common/http';

/*@Component({
    selector: 'app-chatbox',
    templateUrl: './chatbox.component.html',
    styleUrls: ['./chatbox.component.scss']
})

export class ChatboxComponent {// implements OnInit {

    public commService: any;
    public isOnline = true;
    public textMessage = "";
    public inputFocused = false;
    @ViewChild("textInputId") inputEl: ElementRef;
    
    constructor(private modalService: NgbModal) { }

    setComm(cs: CommService) {
        this.commService = cs;
    }
    
    //ngOnInit() { }
    onPanelToggle() {
        this.inputFocused = true;
        this.inputEl.nativeElement.focus();
    }
    
    sendMessage() {
        console.log('sending message');
        this.commService.sendMessage('', '', this.textMessage);

        // also add message as we have not joined the room
        this.commService.Messages.push({ 'from': 'Me', 'icon': '', 'color': 'blue', 'data': this.textMessage });
        this.textMessage = "";
    }
}*/

@Component({
  selector: 'app-minichat',
  templateUrl: './minichat.component.html',
  styleUrls: ['./minichat.component.scss']
})
export class Minichat implements OnInit {// implements OnInit {

  public commService: any;
  public isContactForm = true;
  public isOnline = true;
  public textMessage = "";
  public formEmail = "";
  public formName = "";
  public formMessage = "";
  public inputFocused = false;
  public emailAddress = "";

  @ViewChild("textInputId", { static: false }) inputEl: ElementRef;

  constructor(private http: HttpClient) { }

  setComm(cs: CommService) {
    this.commService = cs;
  }

  onPanelToggle() {
    this.inputFocused = true;
    this.inputEl.nativeElement.focus();
  }

  sendMessage() {
    console.log('sending message');
    this.commService.sendMessage('', '', this.textMessage);

    // also add message as we have not joined the room
    this.commService.Messages.push({ 'from': 'Me', 'icon': '', 'color': 'blue', 'data': this.textMessage });
    this.textMessage = "";
  }

  ngOnInit() {
    // initialize communication
    this.commService = new CommService(this.http);
    this.commService.connectRoom();

    this.setComm(this.commService);
    console.log('ngOnInit minichat')
  }


  step = 0;

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  sendForm() {

    if(this.formMessage == "")
    {
      window.alert("Please write a message before sending.")
    }
    else {
    console.log('sending form: ' + this.formName + ',' + this.formEmail + ',' + this.formMessage);

    this.commService.sendMessage(this.formName, this.formEmail, this.formMessage);
    //this.commService.Messages.push({ 'from': 'Me', 'icon': '', 'color': 'blue', 'data': this.textMessage });

    window.alert("Message sent.")
    }
  }

}

@NgModule({
  imports: [FormsModule,CommonModule,MatInputModule, MatExpansionModule, MatIconModule, MatButtonModule],
  exports: [Minichat],
  declarations: [Minichat],
})
export class MinichatModule {}
